module.exports = __webpack_public_path__ + "static/media/projectExam1.20973046.svg";